import logo from './logo.svg';
import './App.css';
import Temp from './weather/temp'
function App() {
  return (
   <>
     <Temp/>
   </>
  );
}

export default App;
